/* eslint-disable jsx-a11y/alt-text */
import { Font, Image, Link, Page, Text, View } from '@react-pdf/renderer';

import { createPdfStyles } from '../utils/create-pdf-styles';

// Note: this line of code is required to prevent the PDF from hyphenating the title when wrapping.
Font.registerHyphenationCallback((word) => [word]);

const styles = createPdfStyles({
  coverContainer: {
    position: 'relative',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80%',
    textAlign: 'center',
  },
  coverPage: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#E4E4E4',
    position: 'relative',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  coverBackground: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  coverBackgroundContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  logo: {
    width: '223px',
    objectFit: 'contain',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '672px',
  },
  mainTitle: {
    fontFamily: 'PolySans',
    fontWeight: 500,
    fontSize: '65px',
    color: 'white',
    textAlign: 'center',
    marginBottom: '24px',
  },
  subtitle: {
    fontFamily: 'PolySans',
    fontWeight: 500,
    fontSize: '34px',
    color: 'white',
    textAlign: 'center',
  },
  school: {
    backgroundColor: 'blue.500',
    color: 'white',
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '16px',
    fontFamily: 'PolySans',
    marginBottom: '24px',
    textTransform: 'uppercase',
    letterSpacing: 2,
    fontWeight: 500,
  },
  link: {
    fontFamily: 'PolySans',
    textTransform: 'uppercase',
    color: 'white',
    textDecoration: 'none',
    letterSpacing: 1.5,
    fontSize: '14px',
    fontWeight: 500,
  },
});

export function SyllabusCover({ school, title }: { school?: string; title: string }) {
  return (
    <Page size='LETTER' style={styles.coverPage}>
      <View style={styles.coverBackgroundContainer}>
        <Image src='/images/backgrounds/syllabus-cover.png' style={styles.coverBackground} />
      </View>
      <View style={styles.coverContainer}>
        <View>
          <Image src='/images/logos/udacity-accenture.png' style={styles.logo} />
        </View>
        <View style={styles.titleContainer}>
          {!!school && <Text style={styles.school}>{school}</Text>}
          <Text style={styles.mainTitle}>{title}</Text>
          <Text style={styles.subtitle}>Syllabus</Text>
        </View>
        <Link src='https://www.udacity.com' style={styles.link}>
          udacity.com
        </Link>
      </View>
    </Page>
  );
}
